export type CustomSlotPlacement = 'below-message' | 'outside-border'

export function generateInteractionWormholeId(id: string, slot: CustomSlotPlacement) {
  return `${id}-${slot}`
}
